<div class="dealer-selector-list" [class.ship-to]="isShipTo$ | async">
  <h1 [innerHtml]="'dealer.title' | cxTranslate"></h1>
  <span class="subtitle" [innerHtml]="'dealer.subtitle' | cxTranslate"></span>
  <div class="dealer-body">
    <mat-form-field appearance="outline" class="search-input" subscriptSizing="dynamic">
      <mat-label>{{
        (isShipTo$ | async) ? ('dealer.searchShipTo' | cxTranslate) : ('dealer.search' | cxTranslate)
      }}</mat-label>
      <input
        matInput
        [placeholder]="(isShipTo$ | async) ? ('dealer.searchShipTo' | cxTranslate) : ('dealer.search' | cxTranslate)"
        [ngModel]="searchField"
        (ngModelChange)="changed($event)"
      />
      <mat-icon class="material-icons-sharp light search-icon" matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="limit-number">
      <app-sorting
        [sortOptions]="sortOptions"
        (sortListEvent)="sortChange($event)"
        [selectedOption]="sort"
        [useSelectedOptionAsLabel]="true"
        [placeholder]="'dealer.sortNumber' | cxTranslate"
      >
      </app-sorting>
    </div>
    @if (dealerLists$ | async; as response) { @if (response.results.length == 0) {
    <div class="no-result">
      {{ 'dealer.noResult' | cxTranslate }}
    </div>
    } @else {
    <div class="lists">
      @for (list of response.results; track list) {
      <div class="list">
        <app-dealer-list
          [list]="list"
          [isShipTo]="isShipTo$ | async"
          (impersonationChange)="updateImpersonation($event)"
        ></app-dealer-list>
      </div>
      }
    </div>
    @if (response.pagination.totalPages > 1) {
    <div class="pagination-wrapper">
      <app-pagination
        (viewPageEvent)="pageChange($event)"
        [pagination]="initialPaginationModel"
        [hideOnSinglePage]="false"
      ></app-pagination>
    </div>
    } } }
  </div>
</div>
